import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Reserver from "./pages/Reserver";
import Tarifs from "./pages/Tarifs";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import AuthCallback from "./pages/AuthCallback";
import NotFound from "./pages/NotFound";
import CGU from "./pages/CGU";
import RGPD from "./pages/RGPD";
import CookieBanner from "./components/CookieBanner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/reserver" element={<Reserver />} />
                <Route path="/tarifs" element={<Tarifs />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/mon-compte" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
                <Route path="/paiement/succes" element={<PaymentSuccess />} />
                <Route path="/paiement/annule" element={<PaymentCancel />} />
                <Route path="/cgu" element={<CGU />} />
                <Route path="/rgpd" element={<RGPD />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
            <Toaster richColors position="top-right" />

            {/* Mobile fixed CTA button */}
            <div className="md:hidden fixed bottom-0 inset-x-0 z-30 border-t border-border bg-background/95 backdrop-blur-md p-3">
              <a href="/reserver" data-testid="mobile-cta-reserve" className="block w-full text-center py-3 rounded-full bg-[#2B8B8E] hover:bg-[#1F6F73] text-white font-semibold text-sm">
                Réserver un espace
              </a>
            </div>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
